import { isAfter, parseISO } from 'date-fns';

export const removeNullishFieldsParams = (params: Record<any, any> = {}) => {
  Object.entries(params).forEach(([key, value]) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    ) {
      delete params[key];
    }
  });

  return params;
};

function buildFormData(
  formData: FormData,
  data: Record<any, any>,
  parentKey = ""
) {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    let value: any = data;
    if (data && !(data instanceof String) && !(data instanceof Blob)) {
      value = data.toString();
    }
    formData.append(parentKey, value);
  }
}

export const createdFormData = (payload: Record<any, any>) => {
  const formdata = new FormData();

  buildFormData(formdata, payload);

  return formdata;
};

export const isFutureDateTime = (inputDateTime: string): boolean => {
  const now = new Date();
  const givenDateTime = parseISO(inputDateTime); // Parse the input to a Date object

  // Compare the given date-time with the current date-time
  return isAfter(givenDateTime, now);
}



// WEBPACK FOOTER //
// ./src/app/shared/object_helpers.ts